<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectAnalysisDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 10px;" @click="onExportExcelClick">导出</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click=onprocessAnalysisResult>批量处理</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)" @on-select="onselect"
                 @on-select-all="onselectall"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
// import ProcessAnalysisResultModal from '@/view/da/components/process-analysis-result-modal'
// import BatchProcessAnalysisResultModal from '@/view/da/components/batch-process-analysis-result-modal'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'asalarmanalysisresults',
  components: {
    // ProcessAnalysisResultModal,
    // BatchProcessAnalysisResultModal,
  },
  data () {
    return {

      asAlarmTypeFilter: null,
      stateFilter: null,
      alarmTypeFilter: null,
      alarmLevelFilter: null,
      tiredLevelFilter: null,
      deviateTypeFilter: null,
      signTypeFilter: null,

      selectAnalysisDatetime: [],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 分析结果处理
      processAnalysisResultModal: false,
      processAnalysisResultId: null,

      // 批量分析结果处理
      batchProcessAnalysisResultModal: false,
      batchProcessAnalysisResultId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      /**
         * 多选列表
         */
      processAnalysisResultList: [],

      columns: [
        {
          width: 55,
          type: 'selection'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '系统类型',
          resizable: true,
          key: 'asAlarmType',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          filters: this.AsAlarmType,
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.asAlarmTypeFilter = []
              val.forEach(item => {
                this.asAlarmTypeFilter.push(genQueryParam('asAlarmType', 'EQ', item))
              })
            } else {
              this.asAlarmTypeFilter = null
            }
          },
          render: (h, params) => {
            for (let i = 0; i < this.AsAlarmType.length; i++) {
              if (params.row.asAlarmType === this.AsAlarmType[i].value) {
                console.log(params.row.asAlarmType)
                return h('div', this.AsAlarmType[i].label)
              }
            }
          }
        },
        {
          title: '报警id',
          resizable: true,
          key: 'alarmId',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '标志状态',
          resizable: true,
          key: 'state',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          filters: this.AlarmInfoState,
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.state != null) {
              for (let i = 0; i < this.AlarmInfoState.length; i++) {
                if (params.row.state == this.AlarmInfoState[i].value) {
                  return h('label', this.AlarmInfoState[i].label)
                }
              }
            }
          }
        },
        {
          title: '报警/事件类型',
          resizable: true,
          key: 'alarmType',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          render: (h, params) => {
            let selectAsAlarmTypeLabel = null
            if (params.row.asAlarmType != null) {
              for (let i = 0; i < this.AsAlarmType.length; i++) {
                if (params.row.asAlarmType == this.AsAlarmType[i].value) {
                  selectAsAlarmTypeLabel = this.AsAlarmType[i].label
                  break
                }
              }
            }

            if (selectAsAlarmTypeLabel == 'ADAS') {
              if (params.row.alarmType != null) {
                for (let i = 0; i < this.AdasAlarmInfoAlarmType.length; i++) {
                  if (params.row.alarmType == this.AdasAlarmInfoAlarmType[i].value) {
                    return h('label', this.AdasAlarmInfoAlarmType[i].label)
                  }
                }
              }
            } else if (selectAsAlarmTypeLabel == 'DSM') {
              if (params.row.alarmType != null) {
                for (let i = 0; i < this.DsmAlarmInfoAlarmType.length; i++) {
                  if (params.row.alarmType == this.DsmAlarmInfoAlarmType[i].value) {
                    return h('label', this.DsmAlarmInfoAlarmType[i].label)
                  }
                }
              }
            } else if (selectAsAlarmTypeLabel == 'TPMS') {
              if (params.row.alarmType != null) {
                for (let i = 0; i < this.TpmsAlarmInfoAlarmType.length; i++) {
                  if (params.row.alarmType == this.TpmsAlarmInfoAlarmType[i].value) {
                    return h('label', this.TpmsAlarmInfoAlarmType[i].label)
                  }
                }
              }
            } else if (selectAsAlarmTypeLabel == 'BSD') {
              if (params.row.alarmType != null) {
                for (let i = 0; i < this.BsdAlarmInfoAlarmType.length; i++) {
                  if (params.row.alarmType == this.BsdAlarmInfoAlarmType[i].value) {
                    return h('label', this.BsdAlarmInfoAlarmType[i].label)
                  }
                }
              }
            }
          }
        },
        {
          title: '报警级别',
          resizable: true,
          key: 'alarmLevel',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          filters: this.AlarmLevel,
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.alarmLevelFilter = []
              val.forEach(item => {
                this.alarmLevelFilter.push(genQueryParam('alarmLevel', 'EQ', item))
              })
            } else {
              this.alarmLevelFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.alarmLevel != null) {
              for (let i = 0; i < this.AlarmLevel.length; i++) {
                if (params.row.alarmLevel == this.AlarmLevel[i].value) {
                  return h('label', this.AlarmLevel[i].label)
                }
              }
            }
          }
        },
        {
          title: '疲劳程度',
          resizable: true,
          key: 'tiredLevel',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '前车车速',
          resizable: true,
          key: 'frontSpeed',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '前车/行人距离',
          resizable: true,
          key: 'frontDistance',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '偏离类型',
          resizable: true,
          key: 'deviateType',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          filters: this.AdasAlarmInfoDeviateType,
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.deviateTypeFilter = []
              val.forEach(item => {
                this.deviateTypeFilter.push(genQueryParam('deviateType', 'EQ', item))
              })
            } else {
              this.deviateTypeFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.deviateType != null) {
              for (let i = 0; i < this.AdasAlarmInfoDeviateType.length; i++) {
                if (params.row.deviateType == this.AdasAlarmInfoDeviateType[i].value) {
                  return h('label', this.AdasAlarmInfoDeviateType[i].label)
                }
              }
            }
          }
        },
        {
          title: '道路标志识别类型',
          resizable: true,
          key: 'signType',
          sortable: 'custom',
          tooltip: 'true',
          width: 80,
          filters: this.AdasAlarmInfoSignType,
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.signTypeFilter = []
              val.forEach(item => {
                this.signTypeFilter.push(genQueryParam('signType', 'EQ', item))
              })
            } else {
              this.signTypeFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.signType != null) {
              for (let i = 0; i < this.AdasAlarmInfoSignType.length; i++) {
                if (params.row.signType == this.AdasAlarmInfoSignType[i].value) {
                  return h('label', this.AdasAlarmInfoSignType[i].label)
                }
              }
            }
          }
        },
        {
          title: '道路标志识别数据',
          resizable: true,
          key: 'signData',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车速',
          resizable: true,
          key: 'speed',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '高度',
          resizable: true,
          key: 'high',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '车辆信息',
          resizable: true,
          key: 'vehicleInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              let vehicleInfo = params.row.vehicleInfo
              let display = []
              display.push(h('div', '车牌号码:' + (vehicleInfo.registrationNum == null ? '' : vehicleInfo.registrationNum)))
              display.push(h('div', '车架号:' + (vehicleInfo.vin == null ? '' : vehicleInfo.vin)))
              return h('div', display)
            }
          }
        },
        {
          title: '分组名称',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 180,
          render: (h, params) => {
            if (params.row.vehicleInfo.vehicleInfoGroup) {
              return h('div', params.row.vehicleInfo.vehicleInfoGroup.name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '报警时间',
          resizable: true,
          sortable: 'custom',
          key: 'alarmDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.alarmDatetime) {
              let d = new Date(params.row.alarmDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '接收时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'recvDatetime',
          width: 180,
          render: (h, params) => {
            if (params.row.recvDatetime) {
              let d = new Date(params.row.recvDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        // {
        //   title: '历史结果处理备注',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'historyProcessRemark',
        //   minWidth: 180
        // },
        // {
        //   title: '处理备注',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'processRemark',
        //   minWidth: 180
        // },
        // {
        //   title: '处理状态',
        //   resizable: true,
        //   key: 'processState',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 120,
        //   filters: [
        //     {label: '未处理', value: 1},
        //     {label: '正在跟进', value: 2},
        //     {label: '已处理', value: 3}
        //   ],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val.length > 0) {
        //       this.stateFilter = []
        //       val.forEach(item => {
        //         this.stateFilter.push(genQueryParam('processState', 'EQ', item))
        //       })
        //     } else {
        //       this.stateFilter = null
        //     }
        //   },
        //   render: (h, params) => {
        //     let processState = params.row.processState
        //     if (processState === 1) {
        //       return h('div', [
        //         h('Tag', {
        //           props: {
        //             color: 'red'
        //           }
        //         }, '未处理')
        //       ])
        //     } else if (processState === 2) {
        //       return h('div', [
        //         h('Tag', {
        //           props: {
        //             color: 'blue'
        //           }
        //         }, '正在跟进')
        //       ])
        //     } else if (processState === 3) {
        //       return h('div', [
        //         h('Tag', {
        //           props: {
        //             color: 'blue'
        //           }
        //         }, '已处理')
        //       ])
        //     }
        //   }
        // },
        // {
        //   title: '观察时间',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'observationDatetime',
        //   width: 180,
        //   render: function (h, params) {
        //     if (params.row.observationDatetime) {
        //       let d = new Date(params.row.observationDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日'))
        //     }
        //   }
        // },
        // {
        //   title: '分析时间',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'analyzeDatetime',
        //   width: 180,
        //   render: function (h, params) {
        //     if (params.row.analyzeDatetime) {
        //       let d = new Date(params.row.analyzeDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
        //     }
        //   }
        // },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: (h, params) => {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
        // {
        //   title: '操作',
        //   resizable: true,
        //   key: 'action',
        //   align: 'left',
        //   ellipsis: 'true',
        //   fixed: 'right',
        //   width: 90,
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           type: 'primary',
        //           size: 'small',
        //           disabled: false
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.processAnalysisResultId = params.row.id
        //             this.processAnalysisResultModal = true
        //           }
        //         }
        //       }, '结果处理')
        //     ])
        //   }
        // }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'AsAlarmAnalysisResultServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      let queryParams = []
      let qo1 = null
      let qo2 = null
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.offlineFilter) {
        qo2 = this.offlineFilter
      }
      if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
        let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('locateDatetime', 'BTDT', startDatetime, endDatetime))
      }
      let urlparams = {
        qo1: qo1,
        qo2: qo2,
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/da/asalarmanalysisresult/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },
    filterChange () {
      this.setPage(1)
    },
    onselect (selection, row) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onselectall (selection) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onprocessAnalysisResult () {
      /**
         * 给id列表
         * 给处理内容
         * 后端批量处理
         */
      this.batchProcessAnalysisResultModal = true
      this.batchProcessAnalysisResultId = this.processAnalysisResultList
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let qo7 = null

      if (this.asAlarmTypeFilter) {
        qo1 = this.asAlarmTypeFilter
      }

      if (this.stateFilter) {
        qo2 = this.stateFilter
      }

      if (this.alarmTypeFilter) {
        qo3 = this.alarmTypeFilter
      }

      if (this.alarmLevelFilter) {
        qo4 = this.alarmLevelFilter
      }

      if (this.tiredLevelFilter) {
        qo5 = this.tiredLevelFilter
      }

      if (this.deviateTypeFilter) {
        qo6 = this.deviateTypeFilter
      }

      if (this.signTypeFilter) {
        qo7 = this.signTypeFilter
      }

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
        let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('locateDatetime', 'BTDT', startDatetime, endDatetime))
      }

      store.dispatch('AsAlarmAnalysisResultServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_AsAlarmAnalysisResult_GetPageResult) {
        return store.getters.get_AsAlarmAnalysisResult_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_AsAlarmAnalysisResult_GetPageResult) {
        return store.getters.get_AsAlarmAnalysisResult_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_AsAlarmAnalysisResult_GetPageResult) {
        return store.getters.get_AsAlarmAnalysisResult_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
